import React from "react";
import { flowRight as compose } from 'lodash';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import Shimmer from "./Shimmer";

import s from "../Home/HomeItem/HomeItem.css";
import l from "./Skeleton.css";

const HomeSliderSkeleton = () => {

  return (
    <div className={cx('skeletonViewCard', l.SkeletonSliderPadding)}>
      <div className={cx(s.imgContainer)}>
        <div className={cx(s.parent, l.parentBgColor)}>
          <div className={cx(s.children)}>
            <div className={cx(s.content)}>
              <Shimmer />
            </div>
          </div>
        </div>
      </div>
      <div className={cx(l.skeletonContent)}>
        <Shimmer />
      </div>
      <div className={cx(l.skeletonContent)} style={{ width: '55%' }}>
        <Shimmer />
      </div>
      <div className={cx(l.skeletonContent)}>
        <Shimmer />
      </div>
    </div>
  );
};

export default compose(
  withStyles(s, l),
)(HomeSliderSkeleton);
